function linkedId(link) {
  return Number(link?.pk?.id ?? link?.id ?? 0);
}

export function currentContextSubmissionId(submissionId, questionnaireId, readSubmissionField) {
  if (!submissionId) {
    return 0;
  }
  if (linkedId(readSubmissionField(submissionId, "archivedQuestionnaire"))) {
    return 0;
  }
  const belongsTo = linkedId(readSubmissionField(submissionId, "questionnaire"));
  if (!belongsTo) {
    return submissionId;
  }
  return belongsTo === questionnaireId ? submissionId : 0;
}
